import { fontSizeSM, fontWeightStrong } from '@atlas-frontend/design-tokens';
import { Flex, FlexProps } from 'antd';
import { FC, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { DividerHeaderButtons } from './DividerHeaderButtons';

export interface DividerHeaderProps extends PropsWithChildren {
  id: string;
  title: ReactNode;
  count?: number;
  flex?: FlexProps;
  onAddButtonClick?: MouseEventHandler<HTMLButtonElement>;
  onEditButtonClick?: MouseEventHandler<HTMLButtonElement>;
  onCloneButtonClick?: MouseEventHandler<HTMLButtonElement>;
  onDeleteButtonClick?: MouseEventHandler<HTMLElement>;
  onEditGraphClick?: MouseEventHandler<HTMLElement>;
  editGraphLabel?: string;
  hasError?: boolean;
  disabled?: boolean;
  disabledLabel?: string;
  isLoading?: 'add' | 'manage' | 'clone' | 'delete';
}

export const DividerHeader: FC<DividerHeaderProps> = (props) => {
  const { title, count, children, flex } = props;

  return (
    <Flex vertical gap="large" {...flex}>
      <DividerHeaderButtons {...props}>
        <Title align="center" gap="small">
          {count ? `${title} (${count})` : title}
        </Title>
      </DividerHeaderButtons>
      {children}
    </Flex>
  );
};

const Title = styled(Flex)`
  position: relative;
  z-index: 1;
  background-color: white;
  padding-inline: 16px;
  margin-inline: 20px;
  // The same as Divider (see AtlasThemeProvider.tsx)
  font-size: ${fontSizeSM}px;
  font-weight: ${fontWeightStrong};
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;
